// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"684":"5f7456e9","787":"0b6fea02"}[chunkId] + ".chunk.js";
};